import { Component, OnInit, AfterContentInit } from '@angular/core';
import {Http} from "@angular/http";
import { LoginInfoComponent } from "../../user/login-info/login-info.component";
import { Acceso } from "../../../_seguridad/_acceso/acceso";
import { Menu } from "../../../_seguridad/_menu/menu";

import { MenuService } from "../../../_seguridad/_menu/menu.service";
import {BodyService} from "../../../shared/utils/body.service";


@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit, AfterContentInit {

  accesoList: Acceso[] = [];
  menuList: Menu[] = [];
  tieneRrhhChild: boolean = true;
  tieneAutorizaciones: boolean = true;
  tieneAsistencia: boolean = true;
  tieneVacaciones: boolean = true;
  tieneBoletas: boolean = true;
  tieneFirma: boolean = true;
  tieneControlMarcacion: boolean = true;
  tieneArchivoMarcacion: boolean = true;

  tieneSeguridadChild: boolean = true;
  tieneRol: boolean = true;
  tieneUsuario: boolean = true;

  tieneGraficoChild: boolean = true;
  tieneAusencia: boolean = true;
  tienePersonaCesada: boolean = true;
  tieneResumenPlanilla: boolean = true;
  tieneTipoTrabajador:boolean =  true;

  tieneCargaMasivaChild: boolean = true;
  tieneCargaMasivaUsuario: boolean = true;

  constructor(private http: Http,
    private menuService: MenuService,
    private bodyService: BodyService
  ) {    
  }

  ngOnInit() {

    this.accesoList = JSON.parse(sessionStorage.getItem('currentUser')).userSystem.accesos;
    this.menuService.findAll()
    .subscribe(
        pageResponse => {
          
            this.menuList = pageResponse;
            let cantidadRrhh = 0;
            let cantidadSeguridad = 0;
            let cantidadGraficos = 0;
            let cantidadCargaMasiva = 0;
            this.accesoList.forEach(elementAcceso =>{

              this.menuList.forEach(elementMenu =>{
                if(elementAcceso.menuId == elementMenu.id){
                  elementAcceso.menuNombre = elementMenu.nombre;
                  elementAcceso.menuIdPadre = elementMenu.idPadre;
                }                
              });

              if(elementAcceso.menuIdPadre == 10 && elementAcceso.acceso == "1"){
                cantidadRrhh++;
              }

              if(elementAcceso.menuId == 11)
              this.tieneAutorizaciones = (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 12)
              this.tieneAsistencia = (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 13)
              this.tieneVacaciones = (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 14)
              this.tieneBoletas = (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 15)
              this.tieneFirma = (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 16)
                this.tieneControlMarcacion = (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 17)
                this.tieneArchivoMarcacion = (elementAcceso.acceso == "1");


              if(elementAcceso.menuIdPadre == 20 && elementAcceso.acceso == "1"){
                cantidadSeguridad++;
              }

              if(elementAcceso.menuId == 21)              
              this.tieneRol = (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 22)
              this.tieneUsuario = (elementAcceso.acceso == "1");

              if(elementAcceso.menuIdPadre == 30 && elementAcceso.acceso == "1"){
                cantidadGraficos++;
            }

              if(elementAcceso.menuId == 31)
              this.tieneAusencia = (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 32)
              this.tienePersonaCesada = (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 33)
              this.tieneResumenPlanilla= (elementAcceso.acceso == "1");
              if(elementAcceso.menuId == 34)
                this.tieneTipoTrabajador= (elementAcceso.acceso == "1");


              if(elementAcceso.menuIdPadre == 40 && elementAcceso.acceso == "1"){
                cantidadCargaMasiva++;
              }

              if(elementAcceso.menuId == 41)
                this.tieneCargaMasivaUsuario = (elementAcceso.acceso == "1");


            }); 
            
            console.log(this.accesoList);
            this.tieneRrhhChild = cantidadRrhh>0;
            this.tieneSeguridadChild = cantidadSeguridad>0;
            this.tieneGraficoChild = cantidadGraficos>0;
            this.tieneCargaMasivaChild= cantidadCargaMasiva>0;
        } ,
        error => this.bodyService.handleError(error)
    );     


  }

  ngAfterContentInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/navigation.component.ts